import { LocationState } from "history";

// =========================================================
// Rewards
// =========================================================

export interface IReward {
  id?: number;
  name?: string;
  defaultImage?: string;
  imageId?: string;
  pointsRequired?: number;
  quantity?: number;
  added?: boolean;
}
// =========================================================
// Customer Wallet
// =========================================================

export interface ICustomerWalletDetails {
  tenantId: string;
  customerId: string;
  assetSymbol: string;
  assetName: string;
  accountAddress: string;
  accountAssetBalance: string;
}

export enum CustomerWalletStatus {
  Unknown = "UNKNOWN",
  BlockchainDisabledForTenant = "BLOCKCHAIN_DISABLED_FOR_TENANT",
  WalletNotActivated = "WALLET_NOT_ACTIVATED",
  WalletActivated = "WALLET_ACTIVATED"
}

export interface ICustomerWalletDetailsResponse {
  walletStatus: CustomerWalletStatus;
  walletDetails?: ICustomerWalletDetails;
}

// =========================================================
// Tablet data
// =========================================================

export interface ILocationSettings {
  showTabletPurchaseFlow: boolean;
  showTabletRewardsFlow: boolean;
  showTabletPromoCodesFlow: boolean;
}

export interface ITabletData {
  tabletId: string;
  operationMode: TabletOperationMode;
  whiteLabelMode: boolean;
  hasNoInterests?: boolean;
  locationSettings: ILocationSettings;
  tenantId: string;
  usageTypeMode: TabletUsageTypeMode;
}

export interface ITenant {
  id: string;
  name?: string;
  hideLoyaltyMenu?: boolean;
  whiteLabelMode?: boolean;
}

export interface ITabletLocation {
  name: string;
  locationId: string;
  vendorId: string;
  tenantId: string;
}
export interface ITenantLocation {
  name: string;
  locationId: string;
  tenantId: string;
  vendorId: string;
}

export enum TabletOperationMode {
  PointOfSale = "POINT_OF_SALE",
  Kiosk = "KIOSK",
  Event = "EVENT"
}

// =========================================================
// Phone number availability
// =========================================================

export enum PhoneNumberAvailability {
  AvailableGlobally = "AVAILABLE_GLOBALLY",
  AvailableAtThisLocation = "AVAILABLE_AT_THIS_LOCATION",
  NotAvailable = "NOT_AVAILABLE"
}
export interface IRedeemComplete {
  rewardImageBaseUrl?: string;
  location: LocationState;
}

// =========================================================
// Interests
// =========================================================

export interface IInterest {
  name: string;
  image?: string;
  checked: boolean;
  id: string;
}

export interface IUsageType {
  name: string;
  checked: boolean;
  id: string;
}

// =========================================================
// Customer
// =========================================================

export interface ICustomer {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  zipcode: string;
  birthday: string;
  pin: string;
  phoneNumber: string;
  pointsBalance?: number;
  interestIds: string[];
  usageTypeIds: string[];
}

export interface IUpdateCustomerProfileInput {
  customerId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  zipcode?: string;
  birthday?: string;
}

export interface IGetCustomerDetailsInput {
  authToken: string;
}

export interface IGetTcpaDetailsResponse {
  termsAndConditions: string;
  privacyPolicy: string;
}

export interface IGetCurrentLocationResponse {
  me: { location: ITenantLocation };
}

export interface ISignUpCustomerResponse {
  authenticationToken: string;
  pointsEarned: number;
  customerDetails: ICustomer;
}

export interface ISignUpCustomerInput {
  customer: ICustomer;
  tabletOperationMode: TabletOperationMode;
  isMockSignIn: boolean;
}

export interface IPurchaseCategory {
  id: string;
  name: string;
}

export interface ILoggedCustomer {
  authToken: string;
  pointsEarned?: number;
  newCustomer?: boolean;
  newLocation?: boolean;
  hashedPin?: string;
  customer: ICustomer;
  skipInterestsStep?: boolean;
}

export enum TabletUsageTypeMode {
  Unset = "UNSET",
  MedRec = "MED_REC",
  Med = "MED",
  Rec = "REC"
}

export enum CurrentTermsType {
  TermsAndConditions = "termsAndConditions",
  PrivacyPolicy = "privacyPolicy"
}



// WEBPACK FOOTER //
// ./src/api/types.ts